import React, { useEffect, useState } from 'react';
import addPink from '../Images/addPink.png';
import add from '../Images/add.png';
import tick from '../Images/tick.png';
import download from '../Images/download.png';
import food from '../Images/food.png';
import { useParams } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import toast, { Toaster } from "react-hot-toast"


//////

function HealthPlans() {
  const [selectedMt, setSelectedMt] = useState([]);
  const [guideLines, setGuidelines] = useState([]);
  const { id } = useParams();
  const [edit, setEdit] = useState(true);
  const [allMeals, setAllMeals] = useState({});
  console.log(allMeals)
  const [selectedFood, setSelectedFood] = useState(null);
  const [isClicked, setIsClicked] = useState(false);
  const [dishName, setDishName] = useState(1);
  const [dishTime, setDishTime] = useState('');
  const [dishDesc, setDishDesc] = useState('');
  const [mealEditState, setMealEditState] = useState({}); 
  const [meal, setMeal] = useState(null);
  const [mealList, setMealList] = useState([]);
  const [mealUrl, setMealUrl] = useState(null)
  const [currentMeal, setCurrentMeal] = useState(null);
  const [currentImageUrl, setCurrentImageUrl] = useState(null);
  const [searchValue, setSearchValue] = useState('');
  const [showSuggestions, setShowSuggestions] = useState(false);

  useEffect(() => {
    function handleClickOutside(event) {
      if (!event.target.closest('.relative')) {
        setShowSuggestions(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    if (currentMeal) {
      setSearchValue(currentMeal.dish_name.name);
    } else {
      setSearchValue('');
    }
  }, [currentMeal]);

  const handleMt = (mtIndex) => {
    if (selectedMt.includes(mtIndex)) {
      setSelectedMt(selectedMt.filter((index) => index !== mtIndex));
    } else {
      setSelectedMt([...selectedMt, mtIndex]);
    }
  };

  const handleFood = (fIndex) => {
    setSelectedFood(fIndex === selectedFood ? null : fIndex);
    setIsClicked(false); 
  };

  /////////

  const baseurl = `https://viralranipa.pythonanywhere.com`
  
  function grabMeal(e) {
    if (!e.target.value) {
      setMealUrl(null);
      setCurrentImageUrl(null);
      setDishName(1);
      setDishDesc('');
      return;
    }
  
    let value = e.target.value.split('-');
    let imageUrl = value[0];
    let dishId = value[1];
    
    const fullImageUrl = `${process.env.REACT_APP_BASE_URL}${imageUrl}`;
    setMealUrl(fullImageUrl);
    setCurrentImageUrl(fullImageUrl);  // Set the current image URL
    setDishName(dishId);
    
    const selectedMeal = meal?.find(item => item.id === parseInt(dishId));
    if (selectedMeal) {
      setDishDesc(selectedMeal.dishes_description || '');
    }
  }

  const fetchData2 = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/health-meal-plans/${id}/`
      );
      const json = await response.json();
      if (response.ok) {
        setAllMeals(json);
        const defaultSelected = json.meal_times
          .filter((time) => json.meal_plans[time.name]?.length > 0)
          .map((time) => time.id);
        setSelectedMt(defaultSelected);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (meal) {
      console.log("Current meal state:", meal);
    }
  }, [meal]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/api/guidelines/${id}/`
        );
        const json = await response.json();
        const filteredItems = json
          .filter(item => item.id)
          .sort((a, b) => new Date(b.id) - new Date(a.id)).slice(0, 1);

        if (response.ok) {
          setGuidelines(filteredItems);
        }
      } catch (error) {
        console.log(error);
      }
    };


    const fetchMeal = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/api/dish-choices/`
        );
        const json = await response.json();
        if (response.ok) {
      
          console.log("Original data:", json);
          
          // Sort the meals alphabetically
          const sortedMeals = [...json].sort((a, b) => 
            a.name.toLowerCase().localeCompare(b.name.toLowerCase())
          );
          
       
          console.log("Sorted meals:", sortedMeals);
          
          setMeal(sortedMeals);
          setMealList(sortedMeals);
        }
      } catch (error) {
        console.log("Error fetching meals:", error);
      }
    };

    fetchData();
    fetchData2();
    fetchMeal()
  }, [id]);

  const handleDishSubmit = async (e, timeId) => {
    e.preventDefault();
    try {
      // Get the full dish details first
      const selectedMealDetails = meal?.find(item => item.id === parseInt(dishName));
      
      // Create a more detailed formData
      const formData = {
        "meal_time": timeId,
        "dish_name": dishName,
        "dish_time": dishTime,
        "dishes_description": dishDesc,
        "add_to_dietary_recall": true,
        // Add these fields to ensure complete data
        "dish_details": {
          id: dishName,
          name: selectedMealDetails?.name,
          // Add any other relevant dish details
        }
      };
  
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/health-meal-plans/${id}/`,
        {
          method: 'POST',
          body: JSON.stringify(formData),
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
  
      const json = await response.json();
      if (response.ok) {
        console.log(json);
        fetchData2();
        
        // Reset form states
        setMealUrl(null);
        setDishName(1);
        setDishTime('');
        setDishDesc('');
        setIsClicked(!isClicked);
  
        // Add to dietary recall with consistent data
        try {
          const mealTime = allMeals.meal_times.find(time => time.id === timeId)?.name;
          const dietaryRecallData = {
            mealTime: mealTime,
            time: dishTime,
            dishName: selectedMealDetails?.name,
            description: dishDesc,
            fromHealthPlan: true,
            originalDishId: dishName  // Keep reference to original ID
          };
  
          await fetch(
            `${process.env.REACT_APP_BASE_URL}/api/dietary-recalls/${id}/`,
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(dietaryRecallData),
            }
          );
        } catch (error) {
          console.error('Error adding to dietary recall:', error);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleDishDelete = async (mealId) => {  // Remove event parameter
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/health-meal-plans/${id}/${mealId}/`,
        {
          method: "DELETE",
        }
      );
  
      if (response.ok) {
        console.log("Dish deleted successfully");
        fetchData2(); 
        // Also delete from dietary recall if it exists there
        try {
          await fetch(
            `${process.env.REACT_APP_BASE_URL}/api/dietary-recalls/${id}/health-plan/${mealId}/`,
            {
              method: 'DELETE',
            }
          );
        } catch (error) {
          console.error('Error deleting from dietary recall:', error);
        }
      } else {
        const errorData = await response.json();
        console.log("Error deleting dish:", errorData);
      }
    } catch (error) {
      console.log("Network error:", error);
    }
  };

  const handleUpdateMeal = async (mealId, timeId) => {
    try {
      const formData = {
        meal_time: timeId,
        dish_name: dishName,
        dish_time: dishTime,
        dishes_description: dishDesc,
        update_dietary_recall: true //flag to update dietary recall 
      };
  
      console.log('Sending update with data:', formData); // Add this for debugging
  
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/health-meal-plans/${id}/${mealId}/`,
        {
          method: 'PUT',
          body: JSON.stringify(formData),
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
  
      const json = await response.json();
      if (response.ok) {
        console.log('Meal updated:', json);
        fetchData2();
        setMealEditState(prev => ({...prev, [mealId]: false}));
        // Reset states
        setCurrentMeal(null);
        setDishName(1);
        setDishTime('');
        setDishDesc('');
        setCurrentImageUrl(null);  // Reset current image URL
      // Update in dietary recall
      try {
        const mealTime = allMeals.meal_times.find(time => time.id === timeId)?.name;
        const selectedMealDetails = meal?.find(item => item.id === parseInt(dishName));
        
        const dietaryRecallData = {
          mealTime: mealTime,
          time: dishTime,
          dishName: selectedMealDetails?.name,
          description: dishDesc,
          fromHealthPlan: true
        };

        await fetch(
          `${process.env.REACT_APP_BASE_URL}/api/dietary-recalls/${id}/health-plan/${mealId}/`,
          {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(dietaryRecallData),
          }
        );
      } catch (error) {
        console.error('Error updating dietary recall:', error);
      }
    }
  } catch (error) {
    console.error('Error updating meal:', error);
  }
  };

  const handleGuideSubmit = async () => {
    try {
      const formData = {
        "name": guideLines
      };
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/guidelines/${id}/`,
        {
          method: 'POST',
          body: JSON.stringify(formData),
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      const json = await response.json();
      if (response.ok) {
        console.log(json);
        setEdit(true);
      }
      toast.success('Changes Saved Successfully!')

    } catch (error) {
      console.log(error);
    }
  };


  const toggleMealEdit = (meal) => {
    setMealEditState((prevState) => ({
      ...prevState,
      [meal.id]: !prevState[meal.id],
    }));
    
    // Only set the current meal data if we're entering edit mode
    if (!mealEditState[meal.id]) {
      setCurrentMeal(meal);
      setDishName(meal.dish_name.id);
      setDishTime(meal.dish_time);
      setDishDesc(meal.dish_name.dishes_description);
    } else {
      // Reset when exiting edit mode
      setCurrentMeal(null);
      setDishName(1);
      setDishTime('');
      setDishDesc('');
    }
  };

  const handleExport = async () => {
    console.log("Exporting PDF");
    const exportBtn = document.getElementById('exportBtnID');
    exportBtn.disabled = true;
    exportBtn.innerText = 'Exporting...';
    
    try {
        // First API call to get meal plan data
        const response = await fetch(
            `${process.env.REACT_APP_BASE_URL}/api/patient-health-meal-plan-export/${id}/`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            }
        );
        
        let mealPlanData = await response.json();

        // Process meal plans data to ensure dish names are properly formatted
        if (mealPlanData.health_meal_plans && Array.isArray(mealPlanData.health_meal_plans)) {
            mealPlanData.health_meal_plans = mealPlanData.health_meal_plans.map(meal_plan => {
                return {
                    ...meal_plan,
                    dish_name: typeof meal_plan.dish_name === 'object' ? meal_plan.dish_name.name : meal_plan.dish_name
                };
            });
        }

        // Second API call to generate PDF
        const pdfResponse = await fetch(
            'https://anasdew.pythonanywhere.com/export-immuniso-pdf',
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    export_type: 'health_plan',
                    data: mealPlanData
                })
            }
        );

        if (pdfResponse.ok) {
            const pdfBlob = await pdfResponse.blob();
            const url = window.URL.createObjectURL(pdfBlob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'meal-plan.pdf');
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
            exportBtn.disabled = false;
            setTimeout(() => exportBtn.innerText = 'Export PDF Report', 2000);
        } else {
            throw new Error('PDF generation failed');
        }
    } catch (error) {
        console.error("Export failed:", error);
        exportBtn.disabled = false;
        exportBtn.innerText = 'Failed';
        setTimeout(() => exportBtn.innerText = 'Export PDF Report', 2000);
    }
};

  return (
    <div className='healthPlans'>
      <div className='mealTimes'>
        <h1>Meal Time</h1>
        {allMeals?.meal_times?.map((time) => (
          <div
            key={time.id}
            className={selectedMt.includes(time.id) ? 'mtClick' : 'mt'}
            style={{
              border: selectedFood === time.id ? '1px solid #F23D76' : '1px solid transparent',
              backgroundColor: selectedFood === time.id ? '#FFE5ED' : 'white',
            }}
            onClick={() => handleMt(time.id)}
          >
            <button className={selectedMt.includes(time.id) ? 'mtBtnClicked' : 'mtBtn'}>
              <img src={selectedMt.includes(time.id) ? tick : add} alt='add' />
            </button>
            <p>{time.name}</p>
          </div>
        ))}
      </div>

      <div className='allMeals'>
        {selectedMt.map((timeId) => (
          <div className='alm' key={timeId}>
            <div className='almTop' onClick={() => handleFood(timeId)}>
              <h1 className='flex items-center gap-2'><ChevronRight className={`transition-transform duration-300 ${selectedFood === timeId ? 'rotate-90' : 'rotate-0'}`} /> {allMeals.meal_times.find((time) => time.id === timeId)?.name}</h1>
              {selectedFood === timeId && (
                <button
                  onClick={(e) => {
                    e.stopPropagation(); 
                    setIsClicked(!isClicked);
                  }}
                >
                  {!isClicked && <img src={addPink} alt="add" />}
                  <p>{isClicked ? "Cancel" : "Add New Food"}</p>
                </button>
              )}
            </div>
            <div
              className='almAll'
              style={{
                height: selectedFood === timeId ? `${230 * (allMeals.meal_plans[allMeals.meal_times.find((time) => time.id === timeId)?.name]?.length || 0) + (isClicked && selectedFood === timeId ? 300 : 0)}px` : '0px',
                marginBottom: selectedFood === timeId ? '30px' : '0px',
              }}
            >
              {selectedFood === timeId && isClicked && (
                <form style={{ flexDirection: 'column' }} className='food' onSubmit={(e) => handleDishSubmit(e, timeId)}>
                  <div style={{ display: 'flex', justifyContent: 'space-between'}}>
                  <div style={{ position: 'relative' }}>
                  <input type="time" onChange={(e) => setDishTime(e.target.value)} className="time-input" step="60"required/>
    <div style={{ position: 'absolute',top: 0,left: 0,width: '100%',height: '100%',cursor: 'pointer',zIndex: 2}}
    onClick={(e) => {e.currentTarget.previousElementSibling.showPicker();}}/>
    </div>
                    <img src={mealUrl || food} alt="food"className='fImg'onError={(e) => {e.target.src = food; console.log('Error loading image:', mealUrl);}}/>                    
                    <div className='fDesc'>
                      <div className='fdHead'>

                        <div className='fdh'>

                        <div className="relative w-full">
  <input
    type="text"
    value={searchValue}
    onChange={(e) => {
      setSearchValue(e.target.value);
      setShowSuggestions(true);
    }}
    onFocus={() => setShowSuggestions(true)}
    placeholder="Select dish"
    className="w-full p-2 outline-none border-none bg-transparent"
  />
  
  {showSuggestions && searchValue && (
    <div className="absolute z-10 w-full mt-1 bg-white border rounded-md shadow-lg max-h-60 overflow-auto">
      {meal
        ?.filter(mealItem => 
          mealItem.name.toLowerCase().startsWith(searchValue.toLowerCase())
        )
        .map((mealItem) => (
          <div
            key={mealItem.id}
            onClick={() => {
              const optionValue = `${mealItem.dishes_image}-${mealItem.id}`;
              grabMeal({ target: { value: optionValue } });
              setSearchValue(mealItem.name);
              setShowSuggestions(false);
            }}
            className="p-2 hover:bg-gray-100 cursor-pointer"
          >
            {mealItem.name}
          </div>
        ))}
    </div>
  )}
</div>
                        </div>
                        <button className='edit' type='submit'>Save</button>
                      </div>
                      <div className='fd'>
                        <textarea
                          type="text"
                          value={meal?.find(item => item.id === parseInt(dishName))?.dishes_description || dishDesc}
                          placeholder='Description'
                          onChange={(e) => setDishDesc(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>

                </form>
              )}

{(allMeals.meal_plans[allMeals.meal_times.find((time) => time.id === timeId)?.name] || []).map((meal) => (
  <div className='food' key={meal.id}>
{mealEditState[meal.id] ? (
    <input
    type="time" 
    defaultValue={meal.dish_time}
    onChange={(e) => setDishTime(e.target.value)}
    className="" />
     
):(     
    <p className='flex items-center'>{meal.dish_time}</p>
  )} 
   <img 
      src={mealEditState[meal.id] && currentImageUrl 
        ? currentImageUrl 
        : `${process.env.REACT_APP_BASE_URL}${meal.dish_name.dishes_image}` || food} 
      alt={meal.dish_name.name} 
      className='fImg2'
      onError={(e) => {
        e.target.src = food;
        console.log('Error loading image');
      }} 
    />
    <div className='fDesc'>
      <div className='fdHead'>
        <div className='fdh'>
          {mealEditState[meal.id] ? (
            <div>
            
            <div className="relative w-full">
  <input
    type="text"
    value={searchValue}
    onChange={(e) => {
      setSearchValue(e.target.value);
      setShowSuggestions(true);
    }}
    onFocus={() => setShowSuggestions(true)}
    placeholder="Search for a dish..."
    className="w-full p-2"
  />
  
  {showSuggestions && searchValue && (
    <div className="absolute z-10 w-full mt-1 bg-white border rounded-md shadow-lg max-h-60 overflow-auto">
      {mealList
        .filter(mealItem => 
          mealItem.name.toLowerCase().startsWith(searchValue.toLowerCase())
        )
        .map((mealItem) => (
          <div
            key={mealItem.id}
            onClick={() => {
              const optionValue = `${mealItem.dishes_image}-${mealItem.id}`;
              grabMeal({ target: { value: optionValue } });
              setSearchValue(mealItem.name);
              setShowSuggestions(false);
            }}
            className="p-2 hover:bg-gray-100 cursor-pointer"
          >
            {mealItem.name}
          </div>
        ))}
    </div>
  )}
</div>
            </div>
          ) : (
            <div className='flex items-center justify-between'>
              <p className='mr-3'>{meal.dish_name.name}</p>
            </div>
          )}
        </div>
        <div style={{ display: "flex", gap: "10px" }}>
        {mealEditState[meal.id] ? (
  <button 
    type="button"
    className='edit'
    onClick={() => handleUpdateMeal(meal.id, timeId)}
  >
    Save
  </button>
) : (
  <button 
  type="button"
  className='edit'
  onClick={() => {
    setMealEditState(prev => ({...prev, [meal.id]: true}));
    setCurrentMeal(meal);
    setDishTime(meal.dish_time);
    setDishName(meal.dish_name.id);
    setDishDesc(meal.dish_name.dishes_description);
    setCurrentImageUrl(`${process.env.REACT_APP_BASE_URL}${meal.dish_name.dishes_image}`);
  }}
>
  Edit
</button>
)}
       <button 
  type="button"
  className='edit' 
  onClick={() => handleDishDelete(meal.id)}
>
  Delete
</button>
        </div>
      </div>
      {mealEditState[meal.id] ? (
        <textarea
          defaultValue={meal.dish_name.dishes_description}
          placeholder='Description'
          onChange={(e) => setDishDesc(e.target.value)}
          className="w-full p-2 border rounded"
        />
      ) : (
        <p>{meal.dish_name.dishes_description}</p>
      )}
    </div>
  </div>
))}

            </div>
          </div>
        ))}

        {/* ////// */}
        
        <div className='guideLines'>
  <div className='glHead'>
    <Toaster/>
    <h1>Guidelines</h1>
    <button
      onClick={() => {
        if (!edit) handleGuideSubmit();
        setEdit(!edit);
      }}
      style={{
        backgroundColor: edit ? '#F23D76BF' : '#F23D76',
        color: edit ? '#FFFFFF' : '#FFFFFF',
      }}
    >
      {edit ? 'Edit' : 'Save'}
    </button>
  </div>
  <textarea 
    type="text" 
    readOnly={edit} 
    onChange={(e) => setGuidelines(e.target.value)} 
    value={guideLines[0]?.name}
    style={{
      borderColor: !edit ? '#F23D76' : 'transparent',
      transition: 'border-color 0.2s ease'
    }}
  />
</div>

{/* ///// */}

        <button onClick={handleExport} id='exportBtnID' className='exportBtn'>
          <img src={download} alt='download' />
          <p>Export PDF Report</p>
        </button>
      </div>
    </div>
  );
}

export default HealthPlans


